import '@/assets/fonts/index.css'
import '@/styles/main.scss'

import { useAuth } from '@hotelescalle1/heyrev-core-kit/auth-api'

import Main from '@/layout/Main'
import Splash from '@/views/Splash'

const App = () => {
  const { authFinished } = useAuth()

  if (authFinished) return <Main />
  return <Splash />
}

export default App
